<template>
  <Blog />
</template>

<script>
import Blog from '@blog/Blog.vue';
import blogPageMixin from '@/components/mixins/blogPageMixin';
import AppConstantsUtil from '@/services/utils/AppConstantsUtil';
import BrandsEnum from '@shared/enums/BrandsEnum.mjs';

function getHeadInfo(store) {
  return store.dispatch('BlogStore/getBlogArticlesListPageHeadInfo');
}

export default {
  name: 'BlogPage',
  components: {
    Blog
  },
  mixins: [blogPageMixin],
  async asyncData({ store }) {
    const { meta, link, title } = await getHeadInfo(store);
    const brand = store.getters['ContextStore/brand'];
    if (brand === BrandsEnum.OCEAN) {
      await store.dispatch('BlogStore/fetchOceanMaterials', {
        categories: [
          'Dreams & Symbols',
          'Life after Death',
          'Prayers & Remembrance'
        ]
      });
    } else {
      await Promise.all([
        store.dispatch('BlogStore/searchArticlesTags'),
        store.dispatch('BlogStore/searchArticles', {})
      ]);
    }
    return { meta, link, title };
  },
  head() {
    return {
      meta: this.meta,
      title: this.title,
      link: this.link,
      htmlAttrs: {
        class: [
          ...this.htmlClassList,
          AppConstantsUtil.MANAGE_PUBLICATION_SCROLL_CLASS
        ]
      }
    };
  }
};
</script>

<style></style>
